import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { primaryFilterVisibilityAtom } from '../atoms';

// to make this extensible, extract series name and atom as params
function useToggleSeries({ instance, enabled = false, additionalTriggerDeps = [] as any[] }) {
  const showSeries = useAtomValue(primaryFilterVisibilityAtom);

  useEffect(() => {
    if (enabled && instance) {
      const action = showSeries ? 'legendSelect' : 'legendUnSelect';
      instance.dispatchAction({
        type: action,
        name: 'Primary',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, instance, showSeries, ...additionalTriggerDeps]);
}

export default useToggleSeries;
